import React, { useState, useEffect } from "react";
import { Row, Col, Form, Spinner, Modal, Button } from "react-bootstrap";
import { FaEye, FaEdit, FaTrash, FaSearch } from "react-icons/fa";
import "../../Styles/yellowcalf.css/Failed_Transactions.css";
import { simplePostCall } from "../../api/ApiServices";
import ApiConfig from "../../api/ApiConfig";
import { useNavigate } from "react-router-dom";
import ScaleLoader from "react-spinners/ScaleLoader";
import { formatNumber } from "../../utils/formatNumber";

function Failed_Transactions() {
  const customer_currency = (localStorage.getItem("customer_currency") || "").replace(/"/g, "");
  const [transactionList, setTransactionList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [idSearch, setIdSearch] = useState("");

  const [showRetryModal, setShowRetryModal] = useState(false);
const [selectedTransactionId, setSelectedTransactionId] = useState(null);
const [isUpdating, setIsUpdating] = useState(false);

const handleRetryClick = (transactionId) => {
  setSelectedTransactionId(transactionId);
  setShowRetryModal(true);
};


const handleUpdateTransaction = async () => {
  setIsUpdating(true);
  try {
    const payload = {
      customer_id: Number(localStorage.getItem("customer_id")) || 1005,
      api_key:
        localStorage.getItem("api_key") ||
        "b9359f494e77b6589ce12dd62518c585",
      language: "en",
      parent_transactions_id: selectedTransactionId,
    };

    const response = await simplePostCall(
      ApiConfig?.parentfailedtransactionUPDATE,
      JSON.stringify(payload)
    );

    if (response?.result) {
      setShowRetryModal(false);
      setSelectedTransactionId(null);
      fetchFailedTransactions(); // ✅ refresh list
    }
  } catch (error) {
    console.error("Update Error:", error);
  } finally {
    setIsUpdating(false);
  }
};

  const navigate = useNavigate();

  useEffect(() => {
    fetchFailedTransactions();
  }, []);

  const fetchFailedTransactions = async () => {
    setIsLoading(true);
    try {
      const payload = {
        customer_id: Number(localStorage.getItem("customer_id")) || 1005,
        api_key:
          localStorage.getItem("api_key") || "b9359f494e77b6589ce12dd62518c585",
        language: "en",
        status: "failed",
        page: 1,
      };
      const response = await simplePostCall(
        ApiConfig.parentfailedtransaction,
        JSON.stringify(payload),
      );
      if (response?.result) {
        setTransactionList(response.searchModel || []);
      }
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  // Filter Logic
  const filteredData = transactionList.filter((item) => {
    const matchesName = item.student_name
      .toLowerCase()
      .includes(searchTerm.toLowerCase());
    const matchesId = item.student_admission_num.toString().includes(idSearch);
    return matchesName && matchesId;
  });

  return (
    <div className="container-fluid">
      {/* HEADER SECTION */}
      <div className="special-header panel-white-all">
        <h4 className="page-title">
          Parent Failed Transactions
        </h4>
      </div>

      {/* FILTER BAR - Matching the Image */}
      <div className="yc-list-filter">
        <div className="position-relative">
          <FaSearch
            style={{
              position: "absolute",
              top: "50%",
              left: "10px",
              transform: "translateY(-50%)",
              color: "#999",
              fontSize: "15px",
            }}
          />
          <Form.Control
            className="ps-4"
            placeholder=" ID Search"
            value={idSearch}
            onChange={(e) => setIdSearch(e.target.value)}
            style={{ width: "180px", height: "36px", paddingLeft: "30px" }}
          />
        </div>
        <div className="position-relative">
          <FaSearch
            style={{
              position: "absolute",
              top: "50%",
              left: "10px",
              transform: "translateY(-50%)",
              color: "#999",
              fontSize: "15px",
            }}
          />
          <Form.Control
            className="ps-4"
            placeholder=" Filter by Student"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            style={{ width: "180px", height: "36px", paddingLeft: "30px" }}
          />
        </div>
        <button
          className="btn-ft text-white px-4"
          onClick={() => {
            setSearchTerm("");
            setIdSearch("");
          }}
        >
          Clear
        </button>
        <button className="btn-ft px-4">Search</button>
      </div>

      {/* TABLE HEADER */}
      <div className="yc-list-thead-card">
        <Row className="px-3 my-0">
          <Col xs={1}>Sr No</Col>
          <Col xs={1}>ID</Col>
          <Col xs={2}>First Name</Col>
          <Col xs={1}>Grade</Col>
          <Col xs={1}>App Date</Col>
          <Col xs={1}>Due Date</Col>
          <Col xs={1}>Amount</Col>
          <Col xs={1}>Paid</Col>
          <Col xs={1}>Balance</Col>
          <Col xs={2} className="text-center">
            Actions
          </Col>
        </Row>
      </div>

      {/* DATA ROWS - Card Style */}
      {isLoading ? (
        <div className="text-center p-2">
          {" "}
          <ScaleLoader color="#F4BB44" />
        </div>
      ) : (
        filteredData.map((item, index) => (
          <div
            key={index}
            className="yc-list-row-card"
          >
            <Row className="align-items-center small gx-1 text-center my-3">
              <Col xs={1}>{index + 1}</Col>
              <Col xs={1}>{item.parent_transactions_id}</Col>
              <Col xs={2} className="fw-bold">
                {item.student_name}
              </Col>
              <Col xs={1}>{item.student_class}</Col>
              <Col xs={1}>{item.fee_invoice_date?.split("T")[0]}</Col>
              <Col xs={1}>
                {item.fee_invoice_due_date?.split("T")[0] || "-"}
              </Col>
              <Col xs={1}>{customer_currency} {formatNumber(item.fee_invoice_amount_total)}</Col>
              <Col xs={1}>{customer_currency} {formatNumber(item.fee_invoice_total_amount_paid || 0)}</Col>
              <Col xs={1}>
                {customer_currency} {formatNumber(
                  Number(item.fee_invoice_amount_total || 0) -
                  Number(item.fee_invoice_total_amount_paid || 0)
                )}
              </Col>
              <Col xs={2} className="text-center">
                <div className="d-flex justify-content-center gap-3 align-items-center text-muted">
                  <FaEye
                    style={{ cursor: "pointer" }}
                    onClick={() =>
                      navigate(
                        `/accountant/parenttransactions/failedtransactionrecept/${item.parent_transactions_id}`,
                      )
                    }
                  />

        <i
  className="bi bi-arrow-repeat"
  title="Retry"
  style={{ fontSize: "15px", cursor: "pointer" }}
  onClick={() => handleRetryClick(item.parent_transactions_id)}
></i>
                </div>
              </Col>
            </Row>
          </div>
        ))
      )}

      {filteredData.length === 0 && !isLoading && (
        <div className="text-center mt-5">
          No records found matching your search.
        </div>
      )}


      <Modal
  show={showRetryModal}
  onHide={() => !isUpdating && setShowRetryModal(false)}
  centered
>
  <Modal.Header closeButton>
    <Modal.Title>Update Transaction</Modal.Title>
  </Modal.Header>

  <Modal.Body>
    Are you sure you want to update this transaction?
  </Modal.Body>

  <Modal.Footer>
    <Button
      variant="secondary"
      onClick={() => setShowRetryModal(false)}
      disabled={isUpdating}
    >
      Cancel
    </Button>

    <Button
      variant="primary"
      onClick={handleUpdateTransaction}
      disabled={isUpdating}
    >
      {isUpdating ? <Spinner size="sm" /> : "Update"}
    </Button>
  </Modal.Footer>
</Modal>
    </div>
  );
}

export default Failed_Transactions;
